import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { Ticket } from '../../models/support/ticket';

@Injectable({
    providedIn: 'root'
})
export class SupportService {
    constructor(private http: HttpClient) { }
    public createTicket(ticket: Ticket): Observable<Ticket> {
        return this.http.post<Ticket>(`${environment.apiUrl}support/tickets`, ticket);
    }
}
